import React from 'react';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FileElement, truncateFileName } from '../../helpers/Drive';
import { getFileSize } from '../../helpers/File';
import { T } from '../../helpers/Language';
import { InformationCircleOutline } from 'react-ionicons/lib/';

const MAX_STRING_SIZE = 55;

const FileDescItem = ({ label, value, originalValue }) => (
    <tr>
        <td className="p-2 fe-title fe-nostretch">{label}</td>
        <td className="d-flex">
            <div className="flex-grow-1 w-100">{value}</div>
            {originalValue && originalValue.length > MAX_STRING_SIZE && (
                <OverlayTrigger
                    style="mx-7 flex-shrink-1"
                    placement="bottom"
                    overlay={
                        <Tooltip id="filename-tooltip">{originalValue}</Tooltip>
                    }
                >
                    <span style={{ cursor: 'pointer' }}>
                        <InformationCircleOutline width="24px" height="24px" />
                    </span>
                </OverlayTrigger>
            )}
        </td>
    </tr>
);

const FileStatusMap = {
    NEW: ({ label }) => <Badge bg="secondary">Uploaded</Badge>,
    REVIEW: ({ label }) => <Badge bg="info">In Review</Badge>,
    PROCESSING: ({ label }) => <Badge bg="info">In Review</Badge>,
    REWORK_REVIEW: ({ label }) => (
        <Badge bg="info">In Review (Waiting for information)</Badge>
    ),
    REWORK_PROCESSING: ({ label }) => (
        <Badge bg="info">In Review (Waiting for information)</Badge>
    ),
    PUBLISH: ({ label }) => <Badge bg="success">Published</Badge>,
    REJECTED_REVIEW: ({ label }) => <Badge bg="warning">Rejected</Badge>,
    REJECTED_PROCESSING: ({ label }) => <Badge bg="warning">Rejected</Badge>,
    WAITING_FOR_DELETION: ({ label }) => (
        <Badge bg="warning">Will be deleted</Badge>
    ),
    DELETED: ({ label }) => <Badge bg="success">Published</Badge>,
    default: ({ label }) => <Badge bg="primary">{label}</Badge>,
};

export const FileStatus = ({ status }) => {
    const StatusElm = FileStatusMap[status] || FileStatusMap['default'];
    return (
        <>
            <StatusElm label={status} />
        </>
    );
};

export const FileInformation = ({ fileElement, fallback }) => {
    const Fallback = fallback || null;
    if (!fileElement || !fileElement.createdBy || !fileElement.updatedBy)
        return Fallback ? <Fallback /> : <></>;
    let formattedFileName = `${truncateFileName(
        fileElement.fileName,
        MAX_STRING_SIZE
    )}${fileElement.fileExtension}`;

    return (
        <>
            <table className="fe-table">
                <thead></thead>
                <tbody>
                    <FileDescItem
                        label={T('DRIVE_FEXPLORER_FILE_NAME')}
                        value={formattedFileName}
                        originalValue={`${fileElement.fileName}${fileElement.fileExtension}`}
                    />
                    <FileDescItem
                        label={T('DRIVE_FEXPLORER_FILE_SIZE')}
                        value={getFileSize(fileElement.fileSize)}
                    />
                    <FileDescItem
                        label={T('DRIVE_FEXPLORER_FILE_STATUS')}
                        value={<FileStatus status={fileElement.status} />}
                    />
                    <FileDescItem
                        label={T('DRIVE_FEXPLORER_FILE_UPLOADED_AT')}
                        value={FileElement.toHumaneReadableDate(
                            fileElement.createdAt
                        )}
                    />
                    <FileDescItem
                        label={T('DRIVE_FEXPLORER_FILE_LAST_UPDATE')}
                        value={FileElement.toHumaneReadableDate(
                            fileElement.updatedAt
                        )}
                    />
                </tbody>
            </table>
        </>
    );
};

export default FileInformation;
